const getPaymentTermList = ({ page, ...restData }) => ({
  method: "GET",
  url: "/payment_terms",
  data: { ...restData },
});

export const paymentTermsApi = {
  getPaymentTermList,
};
